var Handlebars = require('/Applications/MAMP/htdocs/starzhtml5player/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"content_descriptor\">\n    <div><strong>"
    + alias4(((helper = (helper = lookupProperty(helpers,"ageRestriction") || (depth0 != null ? lookupProperty(depth0,"ageRestriction") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ageRestriction","hash":{},"data":data,"loc":{"start":{"line":2,"column":17},"end":{"line":2,"column":35}}}) : helper)))
    + "</strong></div>\n    <div>"
    + alias4(((helper = (helper = lookupProperty(helpers,"contentDescriptors") || (depth0 != null ? lookupProperty(depth0,"contentDescriptors") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"contentDescriptors","hash":{},"data":data,"loc":{"start":{"line":3,"column":9},"end":{"line":3,"column":31}}}) : helper)))
    + "</div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/modules/content_descriptor/content_descriptor.hbs
// module id = 429
// module chunks = 0